var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-simplePage-list"},[_c('a-card',{attrs:{"bordered":false}},[_vm._v(" list "),_c('render-dom',{attrs:{"render":_vm.useMethodsRender}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }